import { render, staticRenderFns } from "./IconCheckmark.vue?vue&type=template&id=b6a0165e&"
import script from "./IconCheckmark.vue?vue&type=script&lang=js&"
export * from "./IconCheckmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports